export class ServiceState {
  changeSeq = 0;
  lastChangeAt = Date.now();
  lastSnapshotReadyAt = Date.now();
  lastHeartbeatEnqueuedAt = 0;

  updateChange(timestamp = Date.now()) {
    this.lastChangeAt = timestamp;
    this.changeSeq += 1;
  }

  updateSnapshotReady(timestamp = Date.now()) {
    this.lastSnapshotReadyAt = timestamp;
  }

  updateHeartbeat(timestamp = Date.now()) {
    this.lastHeartbeatEnqueuedAt = timestamp;
  }
}
